import {
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  Box,
  Typography,
  Stack,
  Link,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress
} from "@mui/material";
import { useState, useEffect } from "react";

import { darken, lighten } from '@mui/material/styles';

import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc, updateDoc, serverTimestamp } from "firebase/firestore";

import { useNavigate } from 'react-router-dom';

import { useLocation } from "react-router-dom";

import {db} from '../../../../firebaseConfig';

import { createStripeSession, createDodopaymentsSession } from "../../../../common/FunctionCalls";

import { stripePromise, PLANS, paymentProcessor, applicationName, paddleClientSideToken, paddleEnvironmentMode } from "../../../../planConfig";

export default function AccountInfo({ data, onNext, onBack, onChange, activeStep }) {
  const [dialogOpen, setDialogOpen] = useState(false);

  const [loading, setLoading] = useState(false);

  const [planPrice, setPlanPrice] = useState(0);

  const [planPriceId, setPlanPriceId] = useState("");

  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
  
    setLoading(false);
    
    if (data.frequency == null || data.frequency === "" || data.plan == null || data.plan === "")
    {
      const searchParams = new URLSearchParams(location.search);
      const planParam = searchParams.get("plan") || "lite";
      const frequencyParam = searchParams.get("frequency") || "monthly";

      data.frequency = frequencyParam;
      data.plan = planParam;
      
    }
 
  if (PLANS != null && data.frequency != null && data.plan != null)
    {
      if (PLANS.hasOwnProperty(data.frequency.toLowerCase()))
      {
        const thePlanFrequency = PLANS[data.frequency.toLowerCase()];

        if (thePlanFrequency.hasOwnProperty(data.plan.toLowerCase()))
        {
          const thePlan = thePlanFrequency[data.plan.toLowerCase()];

          if (thePlan != null)
          {
            setPlanPrice(thePlan.price);
            setPlanPriceId(thePlan.priceId);
          }
        }
      }
    }
  }, []);

  useEffect(() => {
    if (activeStep === 1) 
    {

      data.companyName = "";
      data.phone = "";      

      const fetchAccountInfo = async () => {
        
        
        const auth = getAuth();

        onAuthStateChanged(auth, async (user) => {
          if (!user) {
            console.log("User is not signed in yet.");
            return;
          }
  
        try {
          const currentUser = auth.currentUser;

          if (!currentUser) return;
    
          const uid = currentUser.uid;
          const userDocRef = doc(db, "appUsers", uid);
          const userSnapshot = await getDoc(userDocRef);
    
          if (!userSnapshot.exists()) return;
    
          const userData = userSnapshot.data();
          const accountNumber = userData.accountNumber;
          if (!accountNumber) return;
    
          const accountDocRef = doc(db, "appAccounts", accountNumber);
          const accountSnapshot = await getDoc(accountDocRef);
    
          if (!accountSnapshot.exists()) return;
    
          const accountData = accountSnapshot.data();
          const updates = {};
    
          updates.accountNumber = accountNumber;

          if (userData.fullName) {
            updates.fullName = userData.fullName;
          }

           if (userData.userSystemInfo?.country) {    
            updates.country = userData.userSystemInfo.country;
          }

          if (userData.email) {
            updates.email = userData.email;
          }
    
          if (accountData.companyName) {
            updates.companyName = accountData.companyName;
          }
    
          if (accountData.phoneNumber) {
            updates.phone = formatPhoneNumber(accountData.phoneNumber);
          }
    
          if (Object.keys(updates).length > 0) {
            onChange(updates);
          }
        } catch (error) {
          console.error("Error fetching account info:", error);
        }
      });
      };
    
      fetchAccountInfo();

    }

  }, [activeStep]);

  
  const goToBilling = async (e) => {
      
      await redirectToCheckout(data.email, data.fullName, data.phone, data.plan, data.frequency, data.companyName, data.accountNumber);
      
  };


  const redirectToCheckout = async (email, name, phone, plan, frequency, companyName, accountNumber ) => {

    try
    {
        switch (paymentProcessor) {
            case "stripe":
              await redirectToCheckoutStripe(email, name, phone, plan, frequency, companyName, accountNumber);
              break;

            case "dodopayments":
              await redirectToCheckoutDodopayments(email, name, phone, plan, frequency, companyName, accountNumber);
              break;

            case "paddle":
              await redirectToCheckoutPaddle(email, name, phone, plan, frequency, companyName, accountNumber);
              break;

            default:
              await redirectToCheckoutStripe(email, name, phone, plan, frequency, companyName, accountNumber);
          }

    } catch (err) {
      console.error("Checkout error:", err);
      setLoading(false);
    }

  };

  
  const redirectToCheckoutStripe = async (email, name, phone, plan, frequency, companyName, accountNumber ) => {

    try
    {
        const auth = getAuth();

        const sessionIdInfo = await createStripeSession( email, name, phone, plan, frequency, companyName, accountNumber, auth);

        if (sessionIdInfo.sessionId) {

          await saveSessionInformation(sessionIdInfo.sessionId);

          const stripe = await stripePromise;
          
          setTimeout(() => {
            setLoading(false);
          }, 10000); // 10,000 milliseconds = 10 seconds

          const { error } = await stripe.redirectToCheckout({ sessionId: sessionIdInfo.sessionId });
          
          if (error) {
            console.error("Stripe redirect error:", error);
            setLoading(false);            
          }

        } else {
          console.error("No session ID returned.");
          setLoading(false);
        }

        setLoading(false);

    } catch (err) {
      console.error("Checkout error:", err);
      setLoading(false);
    }

  };

  const redirectToCheckoutDodopayments = async (email, name, phone, plan, frequency, companyName, accountNumber ) => {

    try
    {
        const auth = getAuth();

        const session = await createDodopaymentsSession( email, name, phone, plan, frequency, companyName, accountNumber, auth);

        if (session) {

          const success = await saveDodoSessionInformation(session);

          console.log("success:"+success);

          if (success==true)
          {
            window.location.href = session.checkout_url;
          }
          
        } else {
          console.error("No session ID returned.");
          setLoading(false);
        }

        setLoading(false);

    } catch (err) {
      console.error("Checkout error:", err);
      setLoading(false);
    }

  };

 const redirectToCheckoutPaddle = async (email, name, phone, plan, frequency, companyName, accountNumber ) => {

  try {
    setLoading(true);
    
    // Initialize Paddle (you can also do this once in useEffect)
    if (window.Paddle) {
      window.Paddle.Environment.set(paddleEnvironmentMode); // Change to "production" for live
      window.Paddle.Initialize({
        token: paddleClientSideToken, // Replace with your client-side token
        eventCallback: function(data) {
          console.log("Paddle Event:", data);
         
          // Handle checkout completion
          if (data.name === "checkout.completed") {
            handlePaddleCheckoutComplete(data);
          }
          
          // Handle checkout close
          if (data.name === "checkout.closed") {
            setLoading(false);
          }
        }
      });
    }
    
    // Save session information before opening checkout
    await updateAccountInformation(); // You may want to remove sessionId parameter
    
    // Define items based on selected plan
    const itemsList = [
      {
        priceId: planPriceId,
        quantity: 1
      }
    ];
    
    // define customer details
    const customerInfo = {
      email: data.email,
      name: data.fullName,  // 👈 Add the customer's name
      address: {
        countryCode: data.country,
        postalCode: ""
      }
    };
    
    // Add custom data to track the subscription
    const customData = {
      accountNumber: data.accountNumber,
      plan: data.plan,
      frequency: data.frequency,
      companyName: data.companyName,
      applicationName: applicationName
    };
    
    // Open Paddle Checkout
    if (window.Paddle) {
      window.Paddle.Checkout.open({
        items: itemsList,
        customer: customerInfo,
        customData: customData,
        settings: {
          theme: "dark"  // 👈 Add this to enable dark theme
        }
      });
    } else {
      console.error("Paddle is not loaded");
      setLoading(false);
      alert("Payment system is not available. Please refresh and try again.");
    }
    
  } catch (err) {
    console.error("Checkout error:", err);
    setLoading(false);
    alert("There was a problem opening checkout. Please try again.");
  }
};


// Handle successful checkout
const handlePaddleCheckoutComplete = async (eventData) => {
  try {
    console.log("Checkout completed:", eventData);
    
    console.log("event Data:", JSON.stringify(eventData.data));

    // Update your database with the transaction information
    const auth = getAuth();
    const currentUser = auth.currentUser;
    
    if (!currentUser) return;
    
    const uid = currentUser.uid;
    const userDocRef = doc(db, "appUsers", uid);
    const userSnapshot = await getDoc(userDocRef);
    
    if (!userSnapshot.exists()) return;
    
    const userData = userSnapshot.data();
    const accountNumber = userData.accountNumber;
    
    if (!accountNumber) return;
    
    const accountDocRef = doc(db, "appAccounts", accountNumber);
    
    // Update with Paddle transaction information
    await updateDoc(accountDocRef, {
      paddleTransactionId: eventData.data?.transaction_id,
      paddleCheckoutId: eventData.data?.id,
      paddleCustomerId: eventData.data?.customer?.id,
      subscriptionFrequency: data.frequency,
      subscriptionPlan: data.plan,
      status: 'active',
      subscriptionType: 'paid',
      lastUpdated: serverTimestamp()
    });
    
    setLoading(false);
    
    // Redirect to success page or next step
    navigate('/app'); // Adjust as needed
    
  } catch (error) {
    console.error("Error handling checkout completion:", error);
    setLoading(false);
  }
};

  const updateAccountInformation = async () => {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
      
      if (!currentUser) { 
        setLoading(false); 
        throw new Error("User not authenticated"); 
      }
      
      const uid = currentUser.uid;
      const userDocRef = doc(db, "appUsers", uid);
      const userSnapshot = await getDoc(userDocRef);
      
      if (!userSnapshot.exists()) { 
        setLoading(false); 
        throw new Error("User record not found");
      }
      
      const userData = userSnapshot.data();
      const accountNumber = userData.accountNumber;
      
      if (!accountNumber) { 
        setLoading(false); 
        throw new Error("Account number missing in user record");
      }
      
      const accountDocRef = doc(db, "appAccounts", accountNumber);
      
      await updateDoc(accountDocRef, {
        checkoutInitiated: serverTimestamp(),
        subscriptionFrequency: data.frequency,
        subscriptionPlan: data.plan
      });
      
    } catch (error) {
      setLoading(false);
      console.error("Error updating account info:", error);
      alert("There was a problem saving your information. Please try again.");
    }
  };

  const saveSessionInformation = async (sessionId) => {

      try {
          const auth = getAuth();
          const currentUser = auth.currentUser;
      
          if (!currentUser) { setLoading(false); throw new Error("User not authenticated"); }
      
          const uid = currentUser.uid;
      
          // Step 1: Get appUser record
          const userDocRef = doc(db, "appUsers", uid);
          const userSnapshot = await getDoc(userDocRef);
      
          if (!userSnapshot.exists()) { setLoading(false); throw new Error("User record not found")};
      
          const userData = userSnapshot.data();
          const accountNumber = userData.accountNumber;
         
          if (!accountNumber) { setLoading(false); throw new Error("Account number missing in user record")};
      
          // Step 2: Update appAccounts record
          const accountDocRef = doc(db, "appAccounts", accountNumber);
      
          await updateDoc(accountDocRef, {
            paymentProcessor:paymentProcessor,
            stripeCheckoutProcessSessionId: sessionId,
            subscriptionFrequency: data.frequency,
            subscriptionPlan: data.plan
          });
      
          // Step 3: Proceed
        } catch (error) {
          setLoading(false);
          console.error("Error updating account sessionId:", error);
          alert("There was a problem saving your information. Please try again.");
        }
  }

    const saveDodoSessionInformation = async (session) => {

      let success = true;

      console.log(JSON.stringify(session));

      try {
          const auth = getAuth();
          const currentUser = auth.currentUser;
      
          if (!currentUser) { setLoading(false); throw new Error("User not authenticated"); }
      
          const uid = currentUser.uid;
      
          // Step 1: Get appUser record
          const userDocRef = doc(db, "appUsers", uid);
          const userSnapshot = await getDoc(userDocRef);
      
          if (!userSnapshot.exists()) { setLoading(false); throw new Error("User record not found")};
      
          const userData = userSnapshot.data();
          const accountNumber = userData.accountNumber;
         
          if (!accountNumber) { setLoading(false); throw new Error("Account number missing in user record")};
      
          // Step 2: Update appAccounts record
          const accountDocRef = doc(db, "appAccounts", accountNumber);
      
          await updateDoc(accountDocRef, {
            paymentProcessor:paymentProcessor,
            dodoCheckoutProcessSessionId: session.session_id,
            dodoCustomerId: session.customer_id,
            subscriptionFrequency: data.frequency,
            subscriptionPlan: data.plan
          });
      
          // Step 3: Proceed
        } catch (error) {

          success = false;
          setLoading(false);
          console.error("Error updating account sessionId:", error);
          alert("There was a problem saving your information. Please try again.");
        }

        return success;
  }

  const handleCheckboxChange = (e) => {
    onChange({ termsAccepted: e.target.checked });
  };

  const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, "").substring(0, 10); // Only digits, max 10
    const phoneParts = [];

    if (digits.length > 0) phoneParts.push("(" + digits.substring(0, 3));
    if (digits.length >= 4) phoneParts.push(") " + digits.substring(3, 6));
    if (digits.length >= 7) phoneParts.push("-" + digits.substring(6, 10));

    return phoneParts.join("");
  };

  const handlePhoneChange = (e) => {
    const formatted = formatPhoneNumber(e.target.value);
    onChange({ phone: formatted });
  };

  const handleContinue = async (e) => {
    e.preventDefault();
  
    setLoading(true);

    if (!data.phone || !data.termsAccepted) {
      setDialogOpen(true);
      setLoading(false);
      return;
    }
  
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;
  
      if (!currentUser) { setLoading(false); throw new Error("User not authenticated"); }
  
      const uid = currentUser.uid;
  
      // Step 1: Get appUser record
      const userDocRef = doc(db, "appUsers", uid);
      const userSnapshot = await getDoc(userDocRef);
  
      if (!userSnapshot.exists()) { setLoading(false); throw new Error("User record not found")};
  
      const userData = userSnapshot.data();
      const accountNumber = userData.accountNumber;
      const userEmail = userData.email;
  
      if (!accountNumber) { setLoading(false); throw new Error("Account number missing in user record")};
  
      // Step 2: Update appAccounts record
      const accountDocRef = doc(db, "appAccounts", accountNumber);
  
      await updateDoc(accountDocRef, {
        companyName: data.companyName || "",
        phoneNumber: data.phone,
        termsOfServiceAcknowledged: true,
        termsOfServiceAcknowledgedDate: serverTimestamp(),
        termsOfServiceAcknowledgedBy:userEmail
      });
  
      // Step 3: Proceed
      await goToBilling();
    } catch (error) {
      setLoading(false);
      console.error("Error updating account info:", error);
      alert("There was a problem saving your information. Please try again.");
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <Box mt={3} sx={{minHeight:'420px', display: 'flex', flexDirection: 'column' }}>

Tell us a little about your business to get started — it only takes a moment!

    <form onSubmit={(e) => handleContinue(e)}>
      <Box sx={{ flexGrow: 1 }}>
            <TextField
              fullWidth
              label="Company Name (Optional)"
              margin="normal"
              value={data.companyName}
              onChange={(e) => onChange({ companyName: e.target.value })}  
              sx={{'& .MuiOutlinedInput-root': {
                backgroundColor: '#FFFFFF',
            '& fieldset': {
              borderColor: lighten('#1B263B',0.2),
              borderWidth: '1.5px',
              boxShadow: '0 0 8px 2px #FFFFFF'}, 
            '&:hover fieldset': {
                borderColor: '#0077CC',
                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)'
                },
            '&.Mui-focused fieldset': {
                borderColor: '#000000',
                boxShadow: '0 0 8px 2px #FFFFFF'
                },},
            '& .MuiInputLabel-root': {
                color:'#000000', 
            '&:hover': {
                color: '#0077CC'},
            '&.Mui-focused': {
                color: 'currentColor',},},}}

            />
            <TextField
              fullWidth 
              required
              label="Phone Number"
              margin="normal"
              value={data.phone}
              onChange={handlePhoneChange}
              inputProps={{ maxLength: 14 }} 
              sx={{'& .MuiOutlinedInput-root': {
                backgroundColor: '#FFFFFF',
            '& fieldset': {
              borderColor: lighten('#1B263B',0.2),
              borderWidth: '1.5px',
              boxShadow: '0 0 8px 2px #FFFFFF'}, 
            '&:hover fieldset': {
                borderColor: '#0077CC',
                boxShadow: '0 0 8px 2px rgba(0,255,0,0.3)'
                },
            '&.Mui-focused fieldset': {
                borderColor: '#000000',
                boxShadow: '0 0 8px 2px #FFFFFF'
                },},
            '& .MuiInputLabel-root': {
                color:'#000000', 
            '&:hover': {
                color: '#0077CC'},
            '&.Mui-focused': {
                color: 'currentColor',},},}}

            />
            <FormControlLabel
              control={
                <Checkbox checked={data.termsAccepted} onChange={handleCheckboxChange} />
              }
              label={<Typography>I agree to the  <Link href="/terms-of-service" target="_blank">Terms of Service</Link></Typography>}
            />
        </Box>
      
        <Box sx={{ alignSelf: 'flex-end', width: '100%' }}>
            <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
              <Button onClick={onBack}>Back</Button>
              <Box textAlign="right">
                <Stack spacing={0.5}>
                  <Button variant="contained" type="submit" 
                   sx={{
                    backgroundColor: lighten('#1B263B',0.1),           // custom color
                    '&:hover': {
                      backgroundColor: darken('#1B263B',0.1),         // darker on hover
                    }
                  }}
                  >
                   <Box sx={{ visibility: loading ? 'hidden' : 'visible' }}>
                      Continue to Billing
                    </Box>

                    {loading && (
                      <CircularProgress
                        size={24}
                        color="inherit"
                        sx={{
                          position: 'absolute',
                          top: '20%',
                          left: '45%',
                          transform: 'translate(-50%, -50%)',
                        }}
                      />
                    )}
                  </Button>
                </Stack>
              </Box>
            </Box>
            <Box textAlign="right" sx={{ paddingTop: "10px" }}>
              <Typography variant="body2" color="textSecondary">
                Secure payment via {paymentProcessor.charAt(0).toUpperCase() + paymentProcessor.slice(1)}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Cancel anytime
              </Typography>
            </Box>

           <Box sx={{textAlign:'left', paddingTop:'30px'}}>
            <u>Your Selected Plan</u>:<br></br>
            {data.frequency === "yearly" ? (
            <>
            {`${data.plan.charAt(0).toUpperCase() + data.plan.slice(1)} - ${data.frequency.charAt(0).toUpperCase() + data.frequency.slice(1)} $${Number(planPrice*12).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}<br />
            </>
            ) : (
            <>
            {`${data.plan.charAt(0).toUpperCase() + data.plan.slice(1)} - ${data.frequency.charAt(0).toUpperCase() + data.frequency.slice(1)} $${Number(planPrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}<br />
            </>
            )}

           <Button
                component="button"
                onClick={() => navigate('/pricing')}
                sx={{
                  color: '#5f5fff',
                  fontSize: '15px',
                  textDecoration: 'none',
                  background: 'none',
                  border: 'none',
                  padding:'0px',
                  margin:'0px',
                  cursor: 'pointer',
                  textTransform: 'none', // 👈 this line fixes the casing
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                <u>Change plan</u>
              </Button>
            </Box> 
           
          </Box>
          </form>
          <Dialog open={dialogOpen} onClose={handleDialogClose}>
              <DialogTitle>Terms of Service Acknowledgement</DialogTitle>
              <DialogContent>
                <Typography>
                  Please  agree to the Terms of Service before continuing.
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleDialogClose}>OK</Button>
              </DialogActions>
            </Dialog>
      </Box>
      
  );
}
